'use strict';

module.exports = /*@ngInject*/

// accordion for family product details
function() {
    return {
        link: function(scope, element, attrs) {
            var toggleAccordion = function toggleAccordion() {
                if (attrs.accordionTarget) {
                    angular.element(this)
                        .toggleClass('active');

                    angular.element(attrs.accordionTarget)
                            .slideToggle()
                            .toggleClass('active');
                } else {
                    angular.element(this)
                        .toggleClass('active')
                        .next()
                            .slideToggle()
                            .toggleClass('active');
                }
            };

            element.bind('click', toggleAccordion);
        }
    };
};
